import React, { useEffect } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./Routes";
import { initializeResizeObserverErrorHandler, cleanupResizeObserverErrorHandler } from "./utils/resizeObserverErrorHandler";

function App() {
  useEffect(() => {
    // Initialize ResizeObserver error handler on app mount
    initializeResizeObserverErrorHandler();

    // Cleanup on unmount
    return () => {
      cleanupResizeObserverErrorHandler();
    };
  }, []);

  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}

export default App;
